export default __webpack_public_path__ + "static/media/visualImg3.99f65050.png";